<template>
  <section>   
    <b-row > 
      <b-col>
            <validation-observer v-slot="{ invalid } ">     
              <b-card > 
                <template v-slot:header >
                  <div class="header-card">
                    Generar Cuentas de Aportes
                  </div> 
                </template> 
                <b-nav tabs>
                  <b-nav-item :active="active===1" @click="resetDataGet();searchSw.value='';active=1;"  class="d-none d-md-block">Centro de trabajo</b-nav-item>
                  <b-nav-item :active="active===2" @click="resetDataGet();searchSw.value='';active=2;"  class="d-none d-md-block">Razón Social</b-nav-item>
                  <b-nav-item :active="active===3" @click="resetDataGet();searchSw.value='';active=3;"  class="d-none d-md-block">Asesor</b-nav-item>
                </b-nav>  
                <div  style="border:1px solid; border-top:none;border-color: #dee2e6;">
                  <br>
                  <!-- Centro de trabajo -->
                    <div v-if="active===1" class="p-1">                 
                      <sw-tableget
                        :alertClass="tableAlertClass"
                        :alertText="tableAlertText"
                        :tableOptions="tableGBoptions"
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        name="tableGet2"
                        @filtrar="searchsData('centro')"
                        @limpiar="limpiarSearchs"
                        @save="saveForm"
                        >   
                        <template v-slot:filtrar>                          
                          <b-row align-v="center" style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03);border: 1px ridge;"> 
                              <sw-searchs
                                :md="4"
                                :lg="4"
                                label='Seleccionar Centro de Trabajo'
                                list='datos_contacto'
                                :filter="[{campo: 'id_list_estado', value: 1}]"
                              >
                              </sw-searchs>  
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Mes Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="mesPeriodo"                   
                                    :options="lists.list_mes"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Año Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="anoPeriodo"                   
                                    :options="lists.list_ano"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                          </b-row>    
                        </template>
                        <template v-slot:modal>
                          <sw-modaleditaraportes 
                            v-if="openModal.modal.modal==='Editar'"
                            @save="saveForm"                     
                            >
                          </sw-modaleditaraportes> 
                        </template>   
                        
                      </sw-tableget>            
                    </div>
                  <!-- Centro de trabajo -->
                    <div v-if="active===2" class="p-1">                 
                      <sw-tableget
                        :alertClass="tableAlertClass"
                        :alertText="tableAlertText"
                        :tableOptions="tableGBoptions"
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        name="tableGet2"
                        @filtrar="searchsData('razon')"
                        @limpiar="limpiarSearchs"
                        @save="saveForm"
                        >   
                        <template v-slot:filtrar>                          
                          <b-row align-v="center" style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03);border: 1px ridge;"> 
                              <sw-searchs
                                :md="4"
                                :lg="4"
                                label='Seleccionar Razón Social'
                                list='datos_razon'
                                :filter="[{campo: 'id_list_estado', value: 1}]"
                              >
                              </sw-searchs>  
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Mes Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="mesPeriodo"                   
                                    :options="lists.list_mes"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Año Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="anoPeriodo"                   
                                    :options="lists.list_ano"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                          </b-row>    
                        </template>
                        <template v-slot:modal>
                          <sw-modaleditaraportes 
                            v-if="openModal.modal.modal==='Editar'"
                            @save="saveForm"                     
                            >
                          </sw-modaleditaraportes> 
                        </template>   
                        
                      </sw-tableget>            
                    </div>
                  <!-- Centro de trabajo -->
                    <div v-if="active===3" class="p-1">                 
                      <sw-tableget
                        :alertClass="tableAlertClass"
                        :alertText="tableAlertText"
                        :tableOptions="tableGBoptions"
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        name="tableGet2"
                        @filtrar="searchsData('asesor')"
                        @limpiar="limpiarSearchs"
                        @save="saveForm"
                        >   
                        <template v-slot:filtrar>                          
                          <b-row align-v="center" style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03);border: 1px ridge;"> 
                              <sw-searchs
                                :md="4"
                                :lg="4"
                                label='Seleccionar Asesor'
                                list='datos_asesor'
                                :filter="[{campo: 'id_list_estado', value: 1}]"
                              >
                              </sw-searchs>  
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Mes Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="mesPeriodo"                   
                                    :options="lists.list_mes"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Año Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="anoPeriodo"                   
                                    :options="lists.list_ano"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                          </b-row>    
                        </template>
                        <template v-slot:modal>
                          <sw-modaleditaraportes 
                            v-if="openModal.modal.modal==='Editar'"
                            @save="saveForm"                     
                            >
                          </sw-modaleditaraportes> 
                        </template>   
                        
                      </sw-tableget>            
                    </div>
                  <!-- loading -->
                </div>             
              </b-card>              
            </validation-observer>                   
      </b-col>
    </b-row>   
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform  from '@/components/forms/saveForm.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwLoading from '@/components/notification/loading.vue'
import { ValidationObserver } from 'vee-validate'
import Multiselect from 'vue-multiselect'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
import SwModalaportes  from '@/components/modals/aportes.vue'
import SwModalaportesgrupal  from '@/components/modals/aportesGrupal.vue'
import SwModaleditaraportes from '@/components/modals/editarAportes.vue'

export default { 
  name: "aportes_registrar",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
    SwInputs,    
    SwSaveform,
    SwTablemultiple,
    SwSearchs,
    SwTableget,
    SwLoading,
    'c-multiselect': Multiselect,  
    VueNumeric,    
    SwModalaportes,
    SwModaleditaraportes,
    SwModalaportesgrupal
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
.aporteDatosAfiliado .form-group {
  margin: 0 !important;
}
</style>